<h1 mat-dialog-title class="notification-title">
	{{ 'mes.production-notes.production-notes' | translate }}
</h1>

<mat-dialog-content class="notes-dialog-content">
	<p class="notes-dialog-subtitle">{{ 'mes.production-notes.shared.order' | translate }} {{ orderNumber }} | {{ 'mes.production-notes.shared.position' | translate }} {{ position }}</p>

	<app-reorder-production-note-list [alias]="alias"></app-reorder-production-note-list>
</mat-dialog-content>

<mat-dialog-actions align="end">
	<button mat-flat-button color="primary" (click)="close()">
		{{ 'general.close' | translate }}
	</button>
</mat-dialog-actions>
